export enum SIGNATURE_MODE {
  SIGN = 'SIGN',
  TYPE = 'TYPE',
  DOWNLOAD = 'DOWNLOAD',
}

export interface Props {
  onSignChange: (image?: string) => void;
  onClear: () => void;
  size?: {
    width?: number;
    height?: number;
  };
  containerClassName?: string;
  disabled?: boolean;
  isMobile?: boolean;
}
